var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import { Tooltip } from 'flowbite-react';
import { Button, Pill } from "../../../../Components/UI";
import { t, Translate } from "../../../../../I18N";


const UsernameHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Username");
const GroupNameHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Name");
const ProtectionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Protection");
const RoleHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Role");
const GroupsHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Group");
const MembersHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Members");
const ActionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Action");

const ProtectionPill = ({ cell }) => {
  if (cell.getValue()) {
    return /*#__PURE__*/(
      _jsx(Pill, { color: "green", className: "whitespace-nowrap" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Password + 2fa")
      ));

  }
  return /*#__PURE__*/(
    _jsx(Pill, { color: "gray" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Password")
    ));

};

const RolePill = ({ cell }) => {
  const value = cell.getValue();
  return /*#__PURE__*/(
    _jsx("div", { className: "whitespace-nowrap" }, void 0, /*#__PURE__*/
    _jsx(Pill, { color: value === 'admin' ? 'primary' : 'gray' }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, value)
    )
    ));

};

const MembersPill = ({
  cell
}) => /*#__PURE__*/
_jsx("div", { className: "flex flex-wrap gap-2" }, void 0,
cell.getValue().map((member) => /*#__PURE__*/
_jsx("div", {}, member.username, /*#__PURE__*/
_jsx(Pill, { color: "gray" }, void 0, member.username)
)
)
);


const GroupsPill = ({ cell }) => {var _cell$getValue;return /*#__PURE__*/(
    _jsx("div", { className: "flex flex-wrap gap-2" }, void 0, (_cell$getValue =
    cell.getValue()) === null || _cell$getValue === void 0 ? void 0 : _cell$getValue.map((group) => /*#__PURE__*/
    _jsx("div", {}, cell.id + group._id, /*#__PURE__*/
    _jsx(Pill, { color: "gray", className: "whitespace-nowrap" }, void 0,
    group.name
    )
    )
    )
    ));};


const UsernameCell = ({ cell }) => {
  const userIsBlocker = cell.row.original.accountLocked;
  return /*#__PURE__*/(
    _jsx("div", { className: "flex items-start gap-1" }, void 0, /*#__PURE__*/
    _jsx("span", { className: userIsBlocker ? 'text-error-600' : '' }, void 0, cell.getValue()),
    userIsBlocker && /*#__PURE__*/
    _jsx(Tooltip, {
      content: t('System', 'Account locked', null, false)
      // eslint-disable-next-line react/style-prop-object
      , style: "light" }, void 0, /*#__PURE__*/

    _jsx(LockClosedIcon, { className: "w-4 cursor-pointer text-error-600" })
    )

    ));

};

const EditButton = ({ onClick }) => /*#__PURE__*/
_jsx(Button, { styling: "outline", onClick: onClick, className: "leading-4" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Edit")
);


const EditUserButton = ({ cell }) => {
  const selectedUser = cell.row.original;
  return /*#__PURE__*/_jsx(EditButton, { onClick: () => {var _cell$column$columnDe, _cell$column$columnDe2;return (_cell$column$columnDe = cell.column.columnDef.meta) === null || _cell$column$columnDe === void 0 ? void 0 : (_cell$column$columnDe2 = _cell$column$columnDe.action) === null || _cell$column$columnDe2 === void 0 ? void 0 : _cell$column$columnDe2.call(_cell$column$columnDe, selectedUser);} });
};

const EditUserGroupButton = ({ cell }) => {
  const selectedUserGroup = cell.row.original;
  return /*#__PURE__*/_jsx(EditButton, { onClick: () => {var _cell$column$columnDe3, _cell$column$columnDe4;return (_cell$column$columnDe3 = cell.column.columnDef.meta) === null || _cell$column$columnDe3 === void 0 ? void 0 : (_cell$column$columnDe4 = _cell$column$columnDe3.action) === null || _cell$column$columnDe4 === void 0 ? void 0 : _cell$column$columnDe4.call(_cell$column$columnDe3, selectedUserGroup);} });
};

const getUsersColumns = (editButtonAction) => {
  const columnHelper = createColumnHelper();
  return [
  columnHelper.accessor('username', {
    header: UsernameHeader,
    cell: UsernameCell,
    meta: { headerClassName: 'w-1/3' }
  }),
  columnHelper.accessor('using2fa', {
    header: ProtectionHeader,
    cell: ProtectionPill,
    meta: { headerClassName: 'w-0' }
  }),
  columnHelper.accessor('role', {
    header: RoleHeader,
    cell: RolePill,
    meta: { headerClassName: 'w-0' }
  }),
  columnHelper.accessor('groups', {
    header: GroupsHeader,
    cell: GroupsPill,
    meta: { headerClassName: 'w-2/3' }
  }),
  columnHelper.display({
    id: '1',
    header: ActionHeader,
    cell: EditUserButton,
    meta: { action: editButtonAction, headerClassName: 'sr-only invisible bg-gray-50' },
    enableSorting: false
  })];

};

const getGroupsColumns = (editButtonAction) => {
  const columnHelper = createColumnHelper();
  return [
  columnHelper.accessor('name', {
    header: GroupNameHeader,
    meta: { headerClassName: 'w-1/4' }
  }),
  columnHelper.accessor('members', {
    header: MembersHeader,
    cell: MembersPill,
    enableSorting: false,
    meta: { headerClassName: 'w-3/4' }
  }),
  columnHelper.display({
    id: '1',
    header: ActionHeader,
    cell: EditUserGroupButton,
    meta: { action: editButtonAction, headerClassName: 'sr-only invisible bg-gray-50' },
    enableSorting: false
  })];

};

export { getUsersColumns, getGroupsColumns };